import React, { type JSX } from 'react';
import { FormControl, FormHelperText, MenuItem, Select, Stack, Switch, TextField } from '@mui/material';
import { useTypedSelector } from '@fiji/common';
import { selectCurrentPermission } from '@fiji/common/src/features/profile/profileSlice';
import { useRBAC } from 'hooks';
import { useTranslation } from 'react-i18next';

export const SettingsRightComponent = ({ item, payload, setPayload, type }: any): JSX.Element => {
    const { t } = useTranslation();
    const selectedNode = useTypedSelector((state) => state['common']['selectedNode']);

    const permissions = useTypedSelector(selectCurrentPermission);
    const { hasPermission } = useRBAC(permissions);
    const canUpdateDevice = hasPermission('edit-devices');
    const isControlDisabled = selectedNode?.connectionStatus === 'Offline' || !canUpdateDevice;

    if (type === 'toggle') {
        return (
            <Switch
                name={item?.name}
                disabled={isControlDisabled}
                checked={payload[item?.name] ?? false}
                onChange={(e): void => {
                    setPayload((prev: any) => ({ ...prev, [e.target.name]: e.target.checked }));
                }}
            />
        );
    }

    if (type === 'select') {
        return (
            <FormControl variant="filled" className="min-width-320">
                <Select
                    className="custom-select"
                    name={item?.channelId}
                    labelId="demo-simlple-select-filled-label"
                    disabled={isControlDisabled}
                    id="demo-simple-select-filled"
                    onChange={(e): void => setPayload((prev: any) => ({ ...prev, [e.target.name]: e.target.value }))}
                    value={payload[item.channelId] ?? ''}
                >
                    {item?.values
                        ?.filter(
                            (option: { value: string; name: string }) => option?.value?.toLowerCase() !== 'battery mute'
                        )
                        .map((option: { value: string; name: string }) => (
                            <MenuItem key={option?.value} value={option?.value}>
                                {option?.name}
                            </MenuItem>
                        ))}
                </Select>
            </FormControl>
        );
    }

    return (
        <Stack>
            <TextField
                onChange={(e): void => {
                    if (item?.dataType === 'Number') {
                        const parsedValue = parseInt(e.target.value);
                        const isWithinRange = item?.min <= parsedValue && parsedValue <= item.max;
                        if (isWithinRange) {
                            setPayload((prev: any) => ({ ...prev, [e.target.name]: e.target.value }));
                        } else {
                            setPayload((prev: any) => ({ ...prev, [e.target.name]: payload[item.channelId] }));
                        }
                        return;
                    }

                    setPayload((prev: any) => ({ ...prev, [e.target.name]: e.target.value }));
                }}
                placeholder={t('COMMON:ENTER_SETTINGS')}
                disabled={isControlDisabled}
                value={payload[item.channelId] ?? ''}
                name={item?.channelId}
                type={item?.dataType === 'Number' ? 'number' : 'text'}
                id="filled-basic"
                label={item?.value}
                variant="filled"
                className="min-width-320"
            />
            {item?.dataType === 'Number' && (
                <FormHelperText sx={{ marginX: '16px' }}>
                    {`${item?.min}-${item?.max} ${item?.unit === 'Sec' ? t('COMMON:TIME.SECONDS') : ''}`}
                </FormHelperText>
            )}
        </Stack>
    );
};
